import { ref } from 'vue';
import { OMSStatus } from '@libs/api-reference';
import { useQueryV2 } from '@libs/use';
import { useUser } from '@core/user';

import * as API from '../requests';
import { ORDERS_QUERY_KEYS } from '../constants';

export const isNewOms = ref(false);

export default function useGetOmsStatusQuery() {
  const { isUserReady } = useUser();

  const { isPending: isLoadingOMSStatus } = useQueryV2<OMSStatus>(
    API.getOMSStatus,
    {
      key: ORDERS_QUERY_KEYS.omsStatus,
      cacheTime: 1000 * 60 * 60 * 24, // 1d
      staleTime: 1000 * 60 * 60 * 24, // 1d
      immediate: isUserReady,
      onSuccess(result) {
        isNewOms.value = result?.data.isMigrated;
      },
    }
  );

  return {
    isLoadingOMSStatus,
    isNewOms,
  };
}
